import { i18n } from '@/i18n';
// eslint-disable-next-line import/no-cycle
import { ComponentData, ComponentMetadata } from '@/types/automated-scenarios';
// eslint-disable-next-line import/no-cycle
import {
  AutomatedScenarioState as state,
  getOperatorChildByOutput,
  isRootOfTree,
} from '@/composables/AutomatedScenarios';
import { required } from '@vuelidate/validators';
// eslint-disable-next-line import/no-cycle
import { includesValuesValidator } from '@/helpers/CustomValidator';
// eslint-disable-next-line import/no-cycle
import { TypeCampaignEnum } from '@/types';

export interface DeclencheurQuitSiteData {
  multiplebox_type: string;
}

let translation: any;
(async () => {
  translation = await i18n;
})();

const DeclencheurQuitSiteMetadata: ComponentMetadata<DeclencheurQuitSiteData> = {
  Meta: {
    kind: 'declencheur',
    id: 'boxquitsite',
    label: 'automatedScenarios.triggers.quitSite.label',
    icon: 'fa-sign-out',
    hasConfiguration: true,
    incompatibilities: {
      automation: {
        next_operators: [
          'boxabandonpanier', 'boxsitepasstime', 'boxquitsite',
          'boxperiodiclaunching', 'boxscrollpage', 'boxstatuscommand',
          'boxcustomjs', 'registeronsite', 'subscribetonewsletter',
          'boxsendemail', 'boxsendsms', 'boxsendfbmessenger',
          'boxsendpushnotification', 'openemail', 'clicklink',
          'boxvisitpage', 'boxtriggerinternalevent', 'boxsendrcs', 'boxsendwhatsapp',
        ],
      },
    },
    component: 'DeclencheurQuitSite',
    availableInCampaign: [],
  },
  Create({ multiplebox_type }: DeclencheurQuitSiteData = {
    multiplebox_type: '0',
  }): ComponentData<DeclencheurQuitSiteData> {
    return {
      id: 'boxquitsite',
      form_name: 'boxquitsite',
      logo_box: 'fa-sign-out',
      multiplebox_type,
    };
  },
  validationRules: (data: any) => ({
    multiplebox_type: {
      required,
      includesValuesValidator: includesValuesValidator(['0', '1']),
    },
  }),
  Outputs(data: DeclencheurQuitSiteData): number {
    return 1;
  },
  CanBeDeleted(operatorId: string): boolean|string {
    const isRoot = isRootOfTree(operatorId);

    if (isRoot) {
      const childOperator = getOperatorChildByOutput(operatorId, 'output_1');
      if (childOperator !== null && typeof (state.scenario.data.operators[childOperator]) !== undefined
        && state.scenario.data.operators[childOperator].properties.class !== 'declencheur') {
        return 'automatedScenarios.cant_remove_operator';
      }
    }

    return true;
  },
  Label(data: DeclencheurQuitSiteData): string {
    if (data.multiplebox_type === '0') return translation.global.t('automatedScenarios.fields.hasQuit');
    return translation.global.t('automatedScenarios.fields.isGoingToQuit');
  },
};

export default DeclencheurQuitSiteMetadata;
